import React from 'react';
import NumberFormat from 'react-number-format';

function real(props) {
    const {inputRef,...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            prefix="R$ "
            decimalScale="2"
            decimalSeparator=","  
            allowNegative ="false"
            fixedDecimalScale="true"   
        />
    )
}

export default real;